import styled from "styled-components";

const FeaturesStyleWrapper = styled.section`
  background: #0d102d;
  position: relative;
  z-index: 1;

  .v1_team_overlay {
    padding: 110px 0;
    position: relative;
    width: 100%;
    height: 100%;
    background: #0d102d;
    z-index: 1;
  }

  .team_content {
    margin-top: 53px;
    position: relative;
    z-index: 1;
    .row {
      row-gap: 30px;
    }
  }



  @media only screen and (max-width: 767px) {
    .v1_team_overlay {
      padding: 30px 0 60px 0;
    }
  }
`;

export default FeaturesStyleWrapper;
